// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-checkmark {
  position: relative;
  display: inline-block;
  width: 104px;
  height: 104px;
  flex: 0 0 auto;
  color: var(--success-default);
}
.success-checkmark svg {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}
.success-checkmark-surface {
  fill: var(--success-soft);
}
.success-checkmark-outline,
.success-checkmark-tick {
  stroke: currentColor;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 1;
  stroke-dashoffset: 0;
}
.success-checkmark-tick,
.success-checkmark-breath {
  transform-box: fill-box;
  transform-origin: center;
}
.success-checkmark-tick {
  stroke-width: 6;
}
.success-checkmark-ripple {
  position: absolute;
  inset: 8px;
  border: 2px solid var(--success-border);
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
}
.success-checkmark.is-animated svg {
  animation: success-checkmark-pop 420ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.success-checkmark.is-animated .success-checkmark-outline {
  transform-origin: center;
  transform: rotate(-90deg);
  animation: success-checkmark-draw 500ms ease-out 120ms both;
}
.success-checkmark.is-animated .success-checkmark-tick {
  animation:
    success-checkmark-draw 360ms ease-out 500ms both,
    success-checkmark-tick-pop 700ms cubic-bezier(0.34, 1.56, 0.64, 1) 300ms both;
}
.success-checkmark.is-pulsing .success-checkmark-breath {
  animation: success-checkmark-breathe 1400ms ease-in-out 1200ms infinite both;
}
.success-checkmark.is-animated .success-checkmark-ripple {
  animation: success-checkmark-ripple 650ms ease-out 750ms both;
}
@keyframes success-checkmark-pop {
  from { opacity: 0; transform: scale(0.8); }
  70% { opacity: 1; transform: scale(1.04); }
  to { opacity: 1; transform: scale(1); }
}
@keyframes success-checkmark-draw {
  from { stroke-dashoffset: 1; }
  to { stroke-dashoffset: 0; }
}
@keyframes success-checkmark-tick-pop {
  from { transform: scale(0.78); }
  55% { transform: scale(1.12); }
  80% { transform: scale(0.97); }
  to { transform: scale(1); }
}
@keyframes success-checkmark-breathe {
  from, to { transform: scale(1); }
  50% { transform: scale(1.035); }
}
@keyframes success-checkmark-ripple {
  from { opacity: 0.65; transform: scale(0.95); }
  to { opacity: 0; transform: scale(1.3); }
}
@media (prefers-reduced-motion: reduce) {
  .success-checkmark.is-pulsing .success-checkmark-breath {
    animation: none;
  }
  .success-checkmark.is-animated svg,
  .success-checkmark.is-animated .success-checkmark-outline,
  .success-checkmark.is-animated .success-checkmark-tick,
  .success-checkmark.is-animated .success-checkmark-ripple {
    animation-duration: 1ms;
    animation-delay: 0ms;
  }
  .success-checkmark.is-animated svg { animation-name: none; }
  .success-checkmark.is-animated .success-checkmark-outline,
  .success-checkmark.is-animated .success-checkmark-tick { animation-name: none; }
  @keyframes success-checkmark-ripple {
    from { opacity: 0; }
    to { opacity: 0; }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SuccessCheckmark/successCheckmark.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,2DAA2D;AAC7D;AACA;EACE;;iFAE+E;AACjF;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,MAAM,UAAU,EAAE,sBAAsB,EAAE;EAC1C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;AACA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;AACA;EACE,OAAO,sBAAsB,EAAE;EAC/B,MAAM,sBAAsB,EAAE;EAC9B,MAAM,sBAAsB,EAAE;EAC9B,KAAK,mBAAmB,EAAE;AAC5B;AACA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,uBAAuB,EAAE;AACjC;AACA;EACE,OAAO,aAAa,EAAE,sBAAsB,EAAE;EAC9C,KAAK,UAAU,EAAE,qBAAqB,EAAE;AAC1C;AACA;EACE;IACE,eAAe;EACjB;EACA;;;;IAIE,uBAAuB;IACvB,oBAAoB;EACtB;EACA,qCAAqC,oBAAoB,EAAE;EAC3D;2DACyD,oBAAoB,EAAE;EAC/E;IACE,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;EACnB;AACF","sourcesContent":[".success-checkmark {\n  position: relative;\n  display: inline-block;\n  width: 104px;\n  height: 104px;\n  flex: 0 0 auto;\n  color: var(--success-default);\n}\n.success-checkmark svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n.success-checkmark-surface {\n  fill: var(--success-soft);\n}\n.success-checkmark-outline,\n.success-checkmark-tick {\n  stroke: currentColor;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 1;\n  stroke-dashoffset: 0;\n}\n.success-checkmark-tick,\n.success-checkmark-breath {\n  transform-box: fill-box;\n  transform-origin: center;\n}\n.success-checkmark-tick {\n  stroke-width: 6;\n}\n.success-checkmark-ripple {\n  position: absolute;\n  inset: 8px;\n  border: 2px solid var(--success-border);\n  border-radius: 50%;\n  opacity: 0;\n  pointer-events: none;\n}\n.success-checkmark.is-animated svg {\n  animation: success-checkmark-pop 420ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n.success-checkmark.is-animated .success-checkmark-outline {\n  transform-origin: center;\n  transform: rotate(-90deg);\n  animation: success-checkmark-draw 500ms ease-out 120ms both;\n}\n.success-checkmark.is-animated .success-checkmark-tick {\n  animation:\n    success-checkmark-draw 360ms ease-out 500ms both,\n    success-checkmark-tick-pop 700ms cubic-bezier(0.34, 1.56, 0.64, 1) 300ms both;\n}\n.success-checkmark.is-pulsing .success-checkmark-breath {\n  animation: success-checkmark-breathe 1400ms ease-in-out 1200ms infinite both;\n}\n.success-checkmark.is-animated .success-checkmark-ripple {\n  animation: success-checkmark-ripple 650ms ease-out 750ms both;\n}\n@keyframes success-checkmark-pop {\n  from { opacity: 0; transform: scale(0.8); }\n  70% { opacity: 1; transform: scale(1.04); }\n  to { opacity: 1; transform: scale(1); }\n}\n@keyframes success-checkmark-draw {\n  from { stroke-dashoffset: 1; }\n  to { stroke-dashoffset: 0; }\n}\n@keyframes success-checkmark-tick-pop {\n  from { transform: scale(0.78); }\n  55% { transform: scale(1.12); }\n  80% { transform: scale(0.97); }\n  to { transform: scale(1); }\n}\n@keyframes success-checkmark-breathe {\n  from, to { transform: scale(1); }\n  50% { transform: scale(1.035); }\n}\n@keyframes success-checkmark-ripple {\n  from { opacity: 0.65; transform: scale(0.95); }\n  to { opacity: 0; transform: scale(1.3); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .success-checkmark.is-pulsing .success-checkmark-breath {\n    animation: none;\n  }\n  .success-checkmark.is-animated svg,\n  .success-checkmark.is-animated .success-checkmark-outline,\n  .success-checkmark.is-animated .success-checkmark-tick,\n  .success-checkmark.is-animated .success-checkmark-ripple {\n    animation-duration: 1ms;\n    animation-delay: 0ms;\n  }\n  .success-checkmark.is-animated svg { animation-name: none; }\n  .success-checkmark.is-animated .success-checkmark-outline,\n  .success-checkmark.is-animated .success-checkmark-tick { animation-name: none; }\n  @keyframes success-checkmark-ripple {\n    from { opacity: 0; }\n    to { opacity: 0; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
